"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShadowMenu = exports.renderShadowMenu = void 0;
const react_1 = __importDefault(require("react"));
const components_common_lazy_render_1 = require("@hotelplan/components.common.lazy-render");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
function renderShadowMenu(links) {
    if (!links)
        return null;
    return (react_1.default.createElement("ul", null, links.map((link, i) => {
        var _a;
        return link.link ? (react_1.default.createElement("li", { key: i },
            react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({}, link.link, { passHref: true }),
                react_1.default.createElement("a", { target: link.target }, link.label)),
            ((_a = link.subLinks) === null || _a === void 0 ? void 0 : _a.length) ? renderShadowMenu(link.subLinks) : null)) : null;
    })));
}
exports.renderShadowMenu = renderShadowMenu;
const RenderShadowMenu = props => {
    return renderShadowMenu(props.links);
};
exports.ShadowMenu = (0, components_common_lazy_render_1.withLazyHydrate)(props => {
    return (react_1.default.createElement("nav", { style: { display: 'none' }, "data-id": "shadow-menu" },
        react_1.default.createElement(RenderShadowMenu, { links: props.links })));
}, {
    ssrOnly: true,
    noWrapper: true,
});
//# sourceMappingURL=ShadowMenu.js.map